export const ADDTEMPLATE = "ADDTEMPLATE"